import { render, staticRenderFns } from "./StudentTicketTable.vue?vue&type=template&id=4235336d&scoped=true&"
import script from "./StudentTicketTable.vue?vue&type=script&lang=js&"
export * from "./StudentTicketTable.vue?vue&type=script&lang=js&"
import style0 from "./StudentTicketTable.vue?vue&type=style&index=0&id=4235336d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4235336d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
